module.exports = __webpack_public_path__ + "static/media/dialogue.9d6c6cfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/dialogue.svg
// module id = 964
// module chunks = 0